import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { withErrorHandler } from "../../app/core-slice";
import { CustomersState } from "./customers.types";
import { customersApi } from "./customers.api";

const initialState: CustomersState = {
    filter: {
        searchTerm: "",
    },
    searchResults: {
        items: [],
        total: 0,
    },
    searchInprogress: false,
};

export const fetchCustomersAsync = createAsyncThunk(
    "customers/searchCustomers",
    withErrorHandler(customersApi.searchCustomers)
);

export const fetchCustomerAsync = createAsyncThunk(
    "customers/fetchCustomer",
    withErrorHandler(customersApi.getCustomer)
);

const customersSlice = createSlice({
    name: "customers",
    initialState,
    reducers: {
        setCustomersFilter(state, action: PayloadAction<any>) {
            state.filter = { ...state.filter, ...action.payload };
        },
        setCreateNewCustomer(state, action: PayloadAction<boolean>) {
            state.createNew = action.payload;
        },
        clearEditingCustomer(state) {
            state.editingCustomer = undefined;
            state.createNew = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomersAsync.pending, (state) => {
                state.searchInprogress = true;
            })
            .addCase(fetchCustomersAsync.fulfilled, (state, action) => {
                state.searchResults = action.payload;
                state.searchInprogress = false;
            })
            .addCase(fetchCustomersAsync.rejected, (state) => {
                state.searchInprogress = false;
            })
            .addCase(fetchCustomerAsync.pending, (state) => {
                state.editingCustomer = undefined;
            })
            .addCase(fetchCustomerAsync.fulfilled, (state, action) => {
                state.editingCustomer = action.payload;
            })
            .addCase(fetchCustomerAsync.rejected, (state) => {
                state.editingCustomer = undefined;
            });
    },
});

export const { clearEditingCustomer, setCreateNewCustomer, setCustomersFilter } = customersSlice.actions;

export default customersSlice.reducer;

//Selectors
export const selectCustomersFilter = (state: RootState) => state.customers.filter;
export const selectCustomersSearchResults = (state: RootState) => state.customers.searchResults;
export const selectCustomersSearchInprogress = (state: RootState) => state.customers.searchInprogress;
export const selectEditingCustomer = (state: RootState) => state.customers.editingCustomer;
export const selectCreateNewCustomer = (state: RootState) => state.customers.createNew;
